import { Routes } from '@angular/router';

export const GIFT_CARD_ROUTES: Routes = [
  { path: '', loadComponent: () => import('./components/gift-card-list/gift-card-list.component').then(m => m.GiftCardListComponent) }
];
